<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card :loading="locationsLoading">
          <v-toolbar color="primary" dark>
            Locations
            <v-spacer></v-spacer>
            <v-btn
              class="btn"
              @click="newLocationsDialog = true"
              outlined
              color="white"
            >
              <v-icon>mdi-plus</v-icon> New
            </v-btn>
          </v-toolbar>
          <v-card-text v-if="locations">
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="3"
                v-for="location in locations"
                :key="location.id"
              >
                <v-card class="mx-auto">
                  <v-card-title>
                    {{ location.name }}
                    <v-chip
                      class="ma-2"
                      :color="locationStatusColor(location.status)"
                      dark
                      label
                    >
                      {{ location.status }}
                    </v-chip>
                  </v-card-title>
                  <v-card-subtitle>
                    {{ location.displayName }}
                  </v-card-subtitle>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="editDetails(location)" text color="primary">
                      Edit
                    </v-btn>

                    <v-btn
                      text
                      @click="switchStatus(location)"
                      :color="locationCardBtnColor(location.status)"
                      :loading="switchStatusLoading == location.id"
                    >
                      {{ locationCardBtnText(location.status) }}
                    </v-btn>
                    <v-btn
                      icon
                      @click="deleteLocation(location.id)"
                      color="red"
                      :loading="locationDeleteLoading == location.id"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="newLocationsDialog">
      <v-card tile>
        <v-toolbar color="primary" dark>
          New Location
          <v-spacer></v-spacer>
          <v-btn color="white" icon dark @click="newLocationsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container style="max-width: 1400px !important">
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="newLocation.name"
                  label="Location Name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="newLocation.displayName"
                  label="Location Display Name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="newLocation.address"
                  label="Location Address"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="newLocation.postCode"
                  label="Location Post Code"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="newLocation.suburb"
                  label="Location Suburb"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="newLocation.city"
                  label="Location City"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="newLocation.phone"
                  label="Location Phone"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="newLocation.email"
                  label="Location Email"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="btn"
            color="primary"
            :loading="newLocationLoading"
            @click="createNewLocation()"
          >
            Create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editLocation" persistent max-width="600px">
      <v-card tile>
        <v-toolbar color="primary" dark>
          Location #{{ selectedLocation.id }}
          <v-spacer></v-spacer>
          <v-btn color="white" icon dark @click="editLocation = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="selectedLocation.name"
                  label="Location Name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="selectedLocation.displayName"
                  label="Location Display Name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="selectedLocation.address"
                  label="Location Address"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="selectedLocation.postCode"
                  label="Location Post Code"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="selectedLocation.suburb"
                  label="Location Suburb"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="selectedLocation.city"
                  label="Location City"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="selectedLocation.phone"
                  label="Location Phone"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="selectedLocation.email"
                  label="Location Email"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="btn"
            @click="saveLocation()"
            color="success"
            :loading="locationSaveLoading"
          >
            Save Location
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { mapGetters } from "vuex";
  import AppBar from "@/components/AppBar";
  import expandedToolbar from "@/components/expandedToolbar.vue";
  import moment from "moment";

  export default {
    components: { AppBar, expandedToolbar },
    computed: {
      ...mapGetters([
        "currentUser",
        "currentUserData",
        "locations",
        "locationsLoading",
      ]),
    },
    props: {
      source: String,
    },
    data: () => ({
      // Ilocatione Upload
      uploadIlocationeDialog: false,
      ilocationeUploadRules: [
        (value) =>
          !value ||
          value.size < 40000000 ||
          "Avatar size should be less than 40 MB!",
      ],
      ilocatione: null,
      previewUrl: null,
      ilocationeUploadLoading: false,
      uploadFileType: null,
      search: "",
      editLocation: false,
      switchStatusLoading: null,
      selectedLocation: {},
      tab: null,
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore locationna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      cb: null,

      // New location
      newLocationsDialog: false,
      newLocation: {},
      newThumbnailIlocatione: null,
      newPDF: null,
      newThumbnailIlocationePreview: false,
      newPDFPreview: false,
      newLocationLoading: false,

      // Save Location
      locationSaveLoading: false,

      // Delete Location
      locationDeleteLoading: null,
    }),
    mounted() {
      this.$store.dispatch("loadLocations");
    },
    methods: {
      locationStatusColor(status) {
        let color = "grey";
        switch (status) {
          case "In-Active":
            color = "red";
            break;
          case "Active":
            color = "green";
            break;
          default:
            break;
        }
        return color;
      },
      locationCardBtnColor(status) {
        let color = "grey";
        switch (status) {
          case "In-Active":
            color = "green";
            break;
          case "Active":
            color = "red";
            break;
          default:
            break;
        }
        return color;
      },
      locationCardBtnText(status) {
        let text = "grey";
        switch (status) {
          case "In-Active":
            text = "Make Active";
            break;
          case "Active":
            text = "Make In-Active";
            break;
          default:
            break;
        }
        return text;
      },
      switchStatus(location) {
        this.switchStatusLoading = location.id;
        if (location.status != "Active") {
          location.status = "Active";
        } else {
          location.status = "In-Active";
        }
        this.$store.dispatch("saveLocation", location).then((result) => {
          this.switchStatusLoading = false;
          if (result.Result == "Success") {
            this.$swal({
              title: "Success!",
              text: "Location has been Updated",
              type: "success",
              confirmButtonText: "Ok",
            });
          } else {
            this.$swal({
              title: "Error!",
              text: "Please try again later",
              type: "error",
              confirmButtonText: "Ok",
            });
          }
        });
      },
      editDetails(location) {
        this.selectedLocation = location;
        this.editLocation = true;
      },
      changeThumbnail() {
        this.uploadFileType = "Thumbnail";
        this.uploadIlocationeDialog = true;
      },
      changePDF() {
        this.uploadFileType = "PDF";
        this.uploadIlocationeDialog = true;
      },
      uploadIlocatione() {
        this.ilocationeUploadLoading = true;
        const payload = {
          id: this.selectedLocation.id,
          type: this.uploadFileType,
          data: this.previewUrl,
        };
        this.$store.dispatch("locationsUpload", payload).then((result) => {
          if (result.Result == "Success") {
            this.$swal({
              title: "Success!",
              text: "Ilocatione has been Uploaded",
              type: "success",
              confirmButtonText: "Ok",
            });
            if (this.uploadFileType == "Thumbnail") {
              let ext = this.previewUrl.match(/.*ilocatione\/(.*);/);
              this.selectedLocation.ilocationeExt = ext[1];
            }

            this.ilocationeUploadLoading = false;
            this.uploadIlocationeDialog = false;
            this.cb = this.r();
          } else {
            this.$swal({
              title: "Error",
              text: "Please try again Later",
              type: "error",
              confirmButtonText: "Ok",
            });
          }
        });
      },
      updatePreviewIlocatione() {
        if (this.ilocatione != undefined) {
          var reader = new FileReader();
          reader.readAsDataURL(this.ilocatione);
          reader.onload = () => {
            this.previewUrl = reader.result;
          };
        } else {
          this.previewUrl = null;
        }
      },
      updateNewPreviewIlocatione(caller) {
        var reader = new FileReader();
        if (caller == "Thumbnail") {
          if (this.newThumbnailIlocatione != undefined) {
            reader.readAsDataURL(this.newThumbnailIlocatione);
            reader.onload = () => {
              this.newThumbnailIlocationePreview = reader.result;
            };
          } else {
            this.newThumbnailIlocationePreview = false;
          }
        } else if (caller == "PDF") {
          if (this.newPDF != undefined) {
            reader.readAsDataURL(this.newPDF);
            reader.onload = () => {
              this.newPDFPreview = reader.result;
            };
          } else {
            this.newPDFPreview = false;
          }
        }
      },
      saveLocation() {
        let payload = this.selectedLocation;
        this.locationSaveLoading = true;
        this.$store.dispatch("saveLocation", payload).then((result) => {
          if (result.Result == "Success") {
            this.locationSaveLoading = false;
            this.editLocation = false;
            this.$swal({
              title: "Success",
              text: "The location has been saved",
              type: "success",
              confirmButtonText: "Ok",
            });
          } else {
            this.locationSaveLoading = false;
            this.$swal({
              title: "Error",
              text: "Please try again later",
              type: "error",
              confirmButtonText: "Ok",
            });
          }
        });
      },
      createNewLocation() {
        this.newLocationLoading = true;
        this.$store.dispatch("newLocation", this.newLocation).then((result) => {
          if (result.Result == "Success") {
            this.newLocationsDialog = false;
            this.newLocation = {};
            this.newLocationLoading = false;
            this.$store.dispatch("loadLocations");
            this.$swal({
              title: "Success",
              text: "The Location has been created",
              type: "success",
              confirmButtonText: "Ok",
            });
          } else {
            this.newLocationLoading = false;
            this.$swal({
              title: "Error!",
              text: "Something went wrong, please try again later",
              type: "error",
              confirmButtonText: "Ok",
            });
          }
        });
      },
      viewPDF(id) {
        window.open(
          `https://telfers-frontend.s3-ap-southeast-2.amazonaws.com/LocationAssets/${id}-PDF.pdf?cb=${
            this.cb
          }&r=${this.r()}`,
          "_blank"
        );
      },
      r() {
        return Math.random().toString(36).substring(7);
      },
      deleteLocation(id) {
        this.$swal({
          title: "Warning",
          text: "You are about to delete a Location, Are you sure you want to continue?",
          type: "warning",
          confirmButtonText: "Continue",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122",
        }).then((res) => {
          if (res.value) {
            let payload = {
              id: id,
            };
            this.locationDeleteLoading = id;
            this.$store.dispatch("deleteLocation", payload).then((result) => {
              if (result.Result == "Success") {
                this.locationDeleteLoading = null;
                this.$swal({
                  title: "Success",
                  text: "The location has been deleted",
                  type: "success",
                  confirmButtonText: "Ok",
                });
              } else {
                this.locationDeleteLoading = null;
                this.$swal({
                  title: "Error",
                  text: "Please try again later",
                  type: "error",
                  confirmButtonText: "Ok",
                });
              }
            });
          }
        });
      },
    },
  };
</script>
